import * as React from 'react';
import { getActions } from './actions.js';
import { reducer } from './reducer.js';
import { getSelectors } from './selectors.js';
import { useContactLensProductData } from '../../../../context/product-context-hooks.js';
import { getInitialState } from './utils/get-initial-state.js';
import { triggerToastMessage } from './utils/trigger-toast-message.js';

const CLEcommContext = /*#__PURE__*/ React.createContext({});
const useCLEcommContext = ()=>React.useContext(CLEcommContext)
;
const CLEcommProvider = ({ children , maxOrderableQuantity  })=>{
    const { activeVariant  } = useContactLensProductData();
    const initialState = React.useMemo(()=>getInitialState({
            sortedAttributesSet: activeVariant.prescriptionRanges,
            lensesPerBox: activeVariant.lensesPerBox,
            maxOrderableQuantity
        })
    , [
        activeVariant
    ]);
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    const selectors = React.useMemo(()=>getSelectors()
    , []);
    React.useDebugValue('CLEcommProvider');
    const value = {
        actions,
        state,
        selectors,
        maxOrderableQuantity,
        triggerToastMessage
    };
    return /*#__PURE__*/ React.createElement(CLEcommContext.Provider, {
        value: value
    }, children);
};

export { CLEcommContext, CLEcommProvider, useCLEcommContext };
//# sourceMappingURL=CLEcommContext.js.map
